import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import lang from "../../helper/langHelper";
import apiPath from "../../constants/apiPath";
import SectionWrapper from "../../components/SectionWrapper";

const ContactUs = ({}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [formDisabled, setFormDisabled] = useState(true);
  const [data, setData] = useState({});
  const [mobileNumber, setMobileNumber] = useState({
    mobile_number: "",
    country_code: "",
  });

  const [mobileNumberCare, setMobileNumberCare] = useState({
    mobile_number: "",
    country_code: "",
  });

  const getData = (id) => {
    request({
      url: `${apiPath.helpCenter}/contact-us`,
      method: "GET",
      onSuccess: ({ data, status }) => {
        if (status) {
          setData(data);
        }
      },
    });
  };

  useEffect(() => {
    getData();
  }, [refresh]);

  const onCreate = (values) => {
    const { permission } = values;
    const payload = {
      ...values,
    };

    payload.mobile_number = mobileNumber.mobile_number;
    payload.country_code = mobileNumber.country_code;

    payload.care_mobile_number = mobileNumberCare.mobile_number;
    payload.care_country_code = mobileNumberCare.country_code;
    setLoading(true);

    request({
      url: `${apiPath.helpCenter + "/addEdit-contact/" + data._id}`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          setRefresh((prev) => !prev);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({
      ...data,

      password: "",
      mobile: data.country_code ? data.country_code + data.mobile_number : "",

      customer_service_mobile: data.care_country_code
        ? data.care_country_code + data.care_mobile_number
        : "",
    });

    setMobileNumber({
      mobile_number: data.mobile_number,
      country_code: data.country_code,
    });

    setMobileNumberCare({
      mobile_number: data.care_mobile_number,
      country_code: data.care_country_code,
    });
  }, [data]);

  const handleChange = (value, data) => {
    var country_code = data.dialCode;
    setMobileNumber({
      country_code: country_code,
      mobile_number: value.slice(data.dialCode.length),
    });
  };

  const handleServiceChange = (value, data) => {
    var country_code = data.dialCode;
    setMobileNumberCare({
      country_code: country_code,
      mobile_number: value.slice(data.dialCode.length),
    });
  };

  return (
    <SectionWrapper
      cardHeading={lang("Contact Us")}
      extra={
        <>
          <div className="w-100 text-head_right_cont">
            <div className="pageHeadingSearch">
              <Button onClick={() => setFormDisabled((prev) => !prev)}>
                {formDisabled ? "Enable" : "Disable"}
              </Button>
            </div>
          </div>
        </>
      }
    >
      <div className="main-new-contact-us-form10">
        <Form
          id="create"
          form={form}
          onFinish={onCreate}
          layout="vertical"
          disabled={formDisabled}
        >
          <Form.Item
            label={<span>{lang("Customer Service")}</span>}
            name="customer_service_mobile"
            rules={[
              {
                required: true,
                validator: (rule, value) => {
                  if (!value) {
                    return Promise.reject(lang("Please enter phone number"));
                  }
                  if (!/^\d{8,12}$/.test(mobileNumberCare?.mobile_number)) {
                    return Promise.reject(
                      lang("Phone number must be between 8 and 12 digits")
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <PhoneInput
              disabled={formDisabled}
              inputProps={{
                name: "mobile",
                required: true,
                autoFocus: false,
                autoFormat: false,
                autoComplete: "off",
              }}
              isValid={(value, country) => {
                if (value.match(/1234/)) {
                  return "Invalid value: " + value + ", " + country.name;
                } else if (value.match(/1234/)) {
                  return "Invalid value: " + value + ", " + country.name;
                } else {
                  return true;
                }
              }}
              country={"jo"}
              preferredCountries={["jo"]}
              onChange={handleServiceChange}
            />
          </Form.Item>
          <Form.Item
            label={<span>{lang("WhatsApp")}</span>}
            name="mobile"
            rules={[
              {
                required: true,
                validator: (rule, value) => {
                  if (!value) {
                    return Promise.reject(lang("Please enter phone number"));
                  }
                  if (!/^\d{8,12}$/.test(mobileNumber?.mobile_number)) {
                    return Promise.reject(
                      lang("Phone number must be between 8 and 12 digits")
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <PhoneInput
              disabled={formDisabled}
              inputProps={{
                name: "mobile",
                required: true,
                autoFocus: false,
                autoFormat: false,
                autoComplete: "off",
              }}
              isValid={(value, country) => {
                if (value.match(/1234/)) {
                  return "Invalid value: " + value + ", " + country.name;
                } else if (value.match(/1234/)) {
                  return "Invalid value: " + value + ", " + country.name;
                } else {
                  return true;
                }
              }}
              country={"jo"}
              preferredCountries={["jo"]}
              onChange={handleChange}
            />
          </Form.Item>
          <Form.Item
            label={<span>{lang("Email ID")}</span>}
            name="email"
            rules={[
              { required: true, message: lang("Please enter the email!") },
              {
                max: 200,
                message: lang(
                  "Email should not contain more then 200 characters!"
                ),
              },
              {
                pattern: new RegExp(
                  /^([a-zA-Z0-9._%-]*[a-zA-Z]+[a-zA-Z0-9._%-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/
                ),
                message: lang("Enter valid email!"),
              },
            ]}
          >
            <Input
              autoComplete="off"
              placeholder={lang("Enter Email Address")}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" className="w-100">
              {lang("Submit")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </SectionWrapper>
  );
};

export default ContactUs;
